export default function Manage() {
    return (
      <section>
       
      </section>
    );
  }